import React from 'react';
import { Form, Col } from 'antd';
import { PartnerSelect, SelectBase, InputText } from '../..';

const optionType = [
    { label: "Partner Code", value: "partnercode" },
    { label: "Award Code", value: "awardcode" },
    { label: "Voucher Code", value: "vouchercode" }
]

class InputTypeVoucher extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            placeholder: 'Partner Code',
            value: 'partnercode'
        }
    }

    componentDidMount = () => {
        this.componentPartnerSelect.retrieveData({}, null, true);
    }

    onChangeType = (value) => {
        this.setState({ value });
        this.props.typeCode(value);
        if (value === 'partnercode') this.componentPartnerSelect.retrieveData({}, null, true);
    }

    onPartnerChange = (partnercode) => {
        if (this.props.onPartnerChange) {
            this.props.onPartnerChange(partnercode);
        }
    }

    render() {
        const { value } = this.state;
        return (
            <Form.Item>
                <Col className="gutter-row" xs={24} sm={24} md={24} lg={6} xl={6}>
                    <SelectBase
                        form={this.props.form}
                        datafield="type"
                        defaultValue="partnercode"
                        options={optionType}
                        allowClear={false}
                        onChange={this.onChangeType}
                    />
                </Col>
                <Col className="gutter-row" xs={24} sm={24} md={24} lg={18} xl={18}>
                    <PartnerSelect
                        ref={(e) => { this.componentPartnerSelect = e }}
                        form={this.props.form}
                        placeholder="Partner"
                        datafield="code"
                        validationrules={['required']}
                        style={{ display: (value === 'partnercode' ? 'block' : 'none') }}
                        onChange={this.onPartnerChange}
                    />
                    <InputText
                        form={this.props.form} 
                        datafield="code" 
                        validationrules={['required']}
                        placeholder="Input Award Code" 
                        style={{ display: (value === 'awardcode' ? 'block' : 'none') }}
                    />
                    <InputText
                        form={this.props.form}
                        placeholder="Input Voucher Code"
                        datafield="code"
                        validationrules={['required']}
                        style={{ display: (value === 'vouchercode' ? 'block' : 'none') }}
                    />
                </Col>
            </Form.Item>
        )
    }
}

export default InputTypeVoucher;
